import { connect } from 'react-redux';
import { requestCommission, editCommission, requestCommissionOverview, removeCommission, exportCommissionList, downloadCommissionInvoice, currencyFilterSet } from '../modules/commission';

import Commissions from '../components/Commissions';

const mapDispatchToProps = {
  requestCommission,
  editCommission,
  requestCommissionOverview,
  exportCommissionList,
  removeCommission,
  downloadCommissionInvoice,
  currencyFilterSet
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.commission.isFetching,
  needFetch: state.commission.needFetch,
  hasError: state.commission.hasError,
  commissions: state.commission.commissions,
  commissionOverview: state.commission.commissionOverview,
  count: state.commission.count,
  id: ownProps.params.id,
  currencyFilter: state.commission.currencyFilter
});

export default connect(mapStateToProps, mapDispatchToProps)(Commissions);



// WEBPACK FOOTER //
// src/routes/commissions/containers/CommissionsContainer.js